import React, { useState, useEffect } from 'react';
import { getMonthlySavings, getMonthlySavingsDates, getEnvironmentalImpact } from 'parity-network-requests';
import Spin from 'antd/lib/spin';
import { useParams } from 'react-router-dom';
import { MonthlyCard } from '../../../MonthlyCard';
import { config } from '../../../../config';

// IMAGES
import environmentalImpactIconLight from '../../../../images/environmental-impact-light.png';
import environmentalImpactIconDark from '../../../../images/environmental-impact-dark.png';
import waitingIcon from '../../../../images/waiting.png';
import waitingOnIcon from '../../../../images/waiting-contract.png';

import './SavingsHome.less';

const { REACT_APP_BUILD_ENV } = config;

export const SavingsHome = (props) => {
  const { theme, buildingName } = props;
  const [monthlyData, setMonthlyData] = useState({});
  const [monthlyDates, setMonthlyDates] = useState([]);
  const [selectedMonthlyDate, setSelectedMonthlyDate] = useState('');
  const [environmentalData, setEnvironmentalData] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const { building } = useParams();

  useEffect(() => {
    async function fetchData() {
      const monthlySavings = await getMonthlySavings(REACT_APP_BUILD_ENV, building);
      setMonthlyData(monthlySavings);
      const monthlyDatesList = await getMonthlySavingsDates(REACT_APP_BUILD_ENV, building);
      setMonthlyDates(monthlyDatesList);
      setSelectedMonthlyDate(monthlyDatesList[0]);
      const environmentalImpact = await getEnvironmentalImpact(REACT_APP_BUILD_ENV, building);
      setEnvironmentalData(environmentalImpact);
      setIsLoading(false);
    }
    fetchData();
    window.document.title = `${buildingName} | Savings Overview`;
  }, [building]);

  const updateMonthlyDate = async (value) => {
    const monthlySavings = await getMonthlySavings(REACT_APP_BUILD_ENV, building, value.date);
    setMonthlyData(monthlySavings);
    setSelectedMonthlyDate(value);
  };

  return (
    <div className={`savings-home savings-home-${theme}`}>
      <div className="savings-home-row-desktop-wrapper">
        <div className="savings-home-row">
          <div className="savings-home__card">
            {isLoading ? (
              <div className="savings-home--loading">
                <Spin />
              </div>
            ) : (
              <MonthlyCard
                monthlyData={monthlyData}
                monthlyDates={monthlyDates}
                selectedMonthlyDate={selectedMonthlyDate}
                updateMonthlyDate={updateMonthlyDate}
                theme={theme}
              />
            )}
          </div>
          <div className="savings-home__card">
            {isLoading ? (
              <div className="savings-home--loading">
                <Spin />
              </div>
            ) : (
              <>
                <div className={`monthly-card monthly-card-${theme}`}>
                  <div className="monthly-card--header">
                    <div className="monthly-card--title">Annual Period</div>
                  </div>
                  <div className="monthly-savings-waiting">
                    <img src={waitingIcon} alt="annual waiting" className="modal-savings-waiting" />
                    <div className="monthly-savings-text-main">We are collecting data right now</div>
                    <div className="monthly-savings-text-secondary">
                      Your savings will appear after software implementation period is complete
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
        <div className="savings-home-row">
          {/* prettier-ignore */}
          <div className="savings-home__card">
            {isLoading ? (
              <div className="savings-home--loading">
                <Spin />
              </div>
            ) : (
              <>
                <div className={`monthly-card monthly-card-${theme}`}>
                  <div className="monthly-card--header">
                    <div className="monthly-card--title">Cumulative Utility Period</div>
                  </div>
                  <div className="monthly-savings-waiting">
                    <img src={waitingOnIcon} alt="cumulative waiting" className="modal-savings-waiting-cumulative" />
                    <div className="monthly-savings-text-main">We are collecting data right now</div>
                    <div className="monthly-savings-text-secondary">
                      Your savings will appear after software implementation period is complete
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
          <div className="savings-home-environment-card-mobile-wrapper">
            {isLoading ? (
              <div className="savings-home--loading">
                <Spin />
              </div>
            ) : (
              <div className="savings-home-environment-card__card--environmental-mobile">
                <div className="building-home-main-savings__card--header">
                  <div className="building-home-main-savings__card--title">Environmental Impact</div>
                </div>
                <div className="building-home-main-savings__card--body">
                  <div className="savings__card-left-arrow" />
                  <div className="savings__card-data">
                    <div className="savings__card-data-group">
                      <div className="savings__card-data-main">
                        {`${environmentalData.co2_emissions_saved
                          .toString()
                          .replace(/\B(?=(\d{3})+(?!\d))/g, ',')} lbs`}
                      </div>
                      <div className="savings__card-data-secondary">CO₂ Emissions Prevented</div>
                    </div>
                    <div className="savings__card-data-group">
                      <div className="savings__card-data-main">
                        {environmentalData.trees_planted.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                      </div>
                      <div className="savings__card-data-secondary">Trees Planted (Equivalent)</div>
                    </div>
                  </div>
                  <div className="savings__card-right-arrow" />
                </div>
                {theme === 'light' ? (
                  <img
                    className="environmental-impact_img"
                    src={environmentalImpactIconLight}
                    alt="environmental-impact"
                  />
                ) : (
                  <img
                    className="environmental-impact_img"
                    src={environmentalImpactIconDark}
                    alt="environmental-impact"
                  />
                )}
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="savings-home-row">
        <div className="savings-home-environment-card-desktop-wrapper">
          {isLoading ? (
            <div className="savings-home--loading">
              <Spin />
            </div>
          ) : (
            <div className="savings-home-environment-card__card--environmental-desktop">
              <div className="building-home-main-savings__card--header">
                <div className="building-home-main-savings__card--title">Environmental Impact22</div>
              </div>
              <div className="building-home-main-savings__card--body">
                <div className="savings__card-left-arrow" />
                <div className="savings__card-data">
                  <div className="savings__card-data-group">
                    <div className="savings__card-data-main">0 lbs</div>
                    <div className="savings__card-data-secondary">CO₂ Emissions Prevented</div>
                  </div>
                  <div className="savings__card-data-group">
                    <div className="savings__card-data-main">0</div>
                    <div className="savings__card-data-secondary">Trees Planted (Equivalent)</div>
                  </div>
                </div>
                <div className="savings__card-right-arrow" />
              </div>
              {theme === 'light' ? (
                <img
                  className="environmental-impact_img"
                  src={environmentalImpactIconLight}
                  alt="environmental-impact"
                />
              ) : (
                <img
                  className="environmental-impact_img"
                  src={environmentalImpactIconDark}
                  alt="environmental-impact"
                />
              )}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
